import { render, staticRenderFns } from "./TheAdditionalSidebar.vue?vue&type=template&id=a4097e84&"
import script from "./TheAdditionalSidebar.vue?vue&type=script&lang=js&"
export * from "./TheAdditionalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheAdditionalSidebar.vue?vue&type=style&index=0&id=a4097e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports